<template lang="pug">
  .container-reg
    header.container-reg-header
      .header-logo-container
        .header-logo
        .header-title
          h1 富慧通
          .header-subtitle 思力智慧旗下的商家管理平台
    .reg-content-container(:class="{ 'reg-content-container-mobile': isMobile }")
      router-view
</template>

<script>
export default {
  computed: {
    isMobile () {
      return window.browserInfo.isMobile;
    },
  },
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-reg {
  .border-box;
  .flex(normal, flex-start, column);
  .max-width;
  min-height:     100%;

  h1 {
    font-size:    16px;
    color:        @white;
  }
  h3 {
    .bold;
    padding-left:   20px;
  }

  .container-reg-header {
    .border-box;
    .max-width;
    .flex(normal, flex-start);

    height:       60px;
    color:        @font-color-black;
    background:   @background-blue;
  }

  .header-logo-container {
    .inline-flex(center, center);
    padding-left:   20px;
  }
  .header-subtitle {
    font-size:    12px;
    color:        @white;
  }

  .header-logo {
    height:   40px;
    width:    40px;
    margin-right:   10px;
    background:   url('../../assets/logo-white.png') center center no-repeat;
    background-size:  contain;
  }

  .reg-content-container {
    .border-box;
    flex:   1;
    width:  1440px;
    margin: 0 auto;

    @media screen and (max-width: 500px) {
      width:  100%;
    }
  }

  .reg-steps {
    padding:  40px;
    @media screen and (max-width: 500px) {
      padding:    20px 10px;

      .el-step__title {
        font-size:  12px;
      }
    }

    .el-step__head, .el-step__description, .el-step__title {
      &.is-finish {
        color:        @background-blue-active;
        border-color: @background-blue-active;
      }
    }
  }

  .reg-form {
    width:  100%;
    margin: 0 auto;

    @media screen and (max-width: 500px) {
      .border-box;
      .max-width;
      padding:  0 20px;

      .el-form-item__label {
        line-height:  16px;
        padding:      10px 0 4px;
      }
    }
  }

  .reg-form-button-group {
    .flex(space-between, center);
    width:  400px;
    margin: 0 auto;

    @media screen and (max-width: 500px) {
      .border-box;
      .max-width;
      padding:  0 20px;
    }
  }

  .reg-button {
    width:    200px;
    margin:   20px 10px;
    height:   30px;
  }
}

.reg-content-container-mobile {
  min-height:   100%;
  background:   @background-grey-2;

  .reg-button {
    display:  block;
    width:    200px;
    margin:   20px auto;
    height:   30px;
  }
}
</style>

